
<template>
  <div>
    <div class="row">
      <div class="leading-cell">
        <div name="title" class="leading">{{title}}</div>
      </div>
      <div name="details" class="cell">
        <div class="details-conainer">
          <div class="details"><slot name="details"></slot></div>
          <div class="logos"><img src="@/assets/geot-hex.png" class="geo-logo"><img src="@/assets/optel-geot.png" class="geo-brand"></div>
        </div>
      </div>
      <div name="code" class="cell">
          <div class="hr">{{code}}</div>
          <img @load="handleLoad" :src="'https://us-central1-optel-ken-passport.cloudfunctions.net/passport_qr_generator?api_key=a99c2b45-e603-4b87-b4f5-b1c503e9cbf9&code=' + code">
      </div>
    </div>
    <div name="footer">
      <hr class="ruler">
      <div class="filler-text">
            T&#x3C;&#x3C;OPTEL GROUP&#x3C;&#x3C;GEOTRACE&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;
            <br>
            Q&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;&#x3C;R&#xC9;SEAU ENVIRONNEMENT&#x3C;&#x3C;&#x3C;&#x3C;20
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PassportContent',
  props: [
    'code',
    'title'
  ],
  methods:{
    handleLoad: function () {
      this.$eventHub.$emit('qr_loaded');
    }
  }
}
</script>

<style>
.details {
  height: 4cm;
  height: 180px;
}
.details-conainer {
  height: 235px;
}
.logos {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.geo-logo {
  height: 1.5cm;
}
.geo-brand {
  height: 1.5cm;
}
.filler-text {
  position:relative;
  top:-7px;
  font-family:monospace;
  font-size: 120%;
  font-weight: bold;
  text-align: center;
}
.ruler {
  width: 90%;
  border-top: 2px solid red
}
.code {
  width:1.75in;
  height: 1.75in;
}
.hr{
  font-size: 190%;
  text-transform: uppercase;
}
.leading-cell {
  max-width: 30px;
}
.leading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 120%;
  color: #898989;
  text-align: center;
  -webkit-transform: rotate(270deg);	
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.cell {
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:center;
}




</style>
